"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.IconPrint = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconPrint = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, style = _a.style;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: __assign(__assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }, style), { height: size, width: size }) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                position: 'relative',
                height: 0,
                width: '100%',
                padding: 0,
                paddingBottom: '100%'
            } }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ style: {
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    left: 0,
                    top: 0
                }, viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M408 112H106a58 58 0 00-58 58v158a56 56 0 0056 56h8v39.68A40.32 40.32 0 00152.32 464h207.36A40.32 40.32 0 00400 423.68V384h8a56 56 0 0056-56V168a56 56 0 00-56-56zm-40 311.68a8.35 8.35 0 01-8.32 8.32H152.32a8.35 8.35 0 01-8.32-8.32V264.32a8.35 8.35 0 018.32-8.32h207.36a8.35 8.35 0 018.32 8.32zm26-215.76a24 24 0 1122-22 24 24 0 01-22 22zM344 48H168a56.09 56.09 0 00-55.42 48h286.84A56.09 56.09 0 00344 48z", fill: "currentColor" }, void 0) }), void 0) }), void 0) }), void 0));
};
exports.IconPrint = IconPrint;
